(function () {
  'use strict';

  var script = document.querySelector('[data-geo-language-redirect]');
  var url = new URL(window.location.href);
  if (!script || window.acmerGeoLanguageRedirect || url.hostname !== 'eu.acmerlaser.com') return;
  if (window.Shopify && (window.Shopify.designMode || window.Shopify.inspectMode)) return;
  if (url.searchParams.has('preview_theme_id') || url.searchParams.has('preview_key')) return;
  window.acmerGeoLanguageRedirect = true;

  var languages;
  try {
    languages = JSON.parse(script.dataset.languages);
  } catch (error) {
    return;
  }
  if (!Array.isArray(languages)) return;

  var countryLanguages = { DE: 'de', FR: 'fr', IT: 'it', ES: 'es' };
  var sessionKey = 'acmer:geo-language-checked:v1';
  var preferenceKey = 'acmer:manual-language:v1';
  var manualChoice = false;

  function readStorage(type, key) {
    try { return window[type].getItem(key); } catch (error) { return null; }
  }

  function writeStorage(type, key, value) {
    try { window[type].setItem(key, value); } catch (error) { /* Storage can be disabled. */ }
  }

  function rememberLanguage(language) {
    if (languages.indexOf(language) === -1) return;
    manualChoice = true;
    writeStorage('localStorage', preferenceKey, language);
    writeStorage('sessionStorage', sessionKey, '1');
  }

  // Capture before the existing selectors call form.submit() (which emits no submit event).
  document.addEventListener('change', function (event) {
    var field = event.target;
    if (field.matches('select[name="locale_code"], select[name="language_code"]')) {
      rememberLanguage(field.value);
    }
  }, true);

  document.addEventListener('click', function (event) {
    var option = event.target.closest('[data-disclosure-locale] [data-disclosure-option]');
    if (option) rememberLanguage(option.dataset.value);
  }, true);

  document.addEventListener('submit', function (event) {
    var field = event.target.querySelector('[name="locale_code"], [name="language_code"]');
    if (field) rememberLanguage(field.value);
  }, true);

  // An explicit language URL takes priority over automatic country detection.
  var prefix = url.pathname.split('/')[1].toLowerCase();
  if (languages.indexOf(prefix) !== -1 || /^(de|fr|it|es)(-|$)/.test(prefix)) {
    writeStorage('sessionStorage', sessionKey, '1');
    return;
  }
  if (/^\/(account|cart|checkout|checkouts|challenge|password|apps|localization)(\/|$)/.test(url.pathname)) return;
  if (readStorage('sessionStorage', sessionKey)) return;
  if (languages.indexOf(readStorage('localStorage', preferenceKey)) !== -1) return;

  var controller = new AbortController();
  var timeout = window.setTimeout(function () { controller.abort(); }, 3000);

  // Use Shopify's detected IP country, not the selected market or browser language.
  fetch('/browsing_context_suggestions.json?country[enabled]=true&language[enabled]=false', {
    credentials: 'same-origin',
    cache: 'no-store',
    signal: controller.signal
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Country detection unavailable');
      return response.json();
    })
    .then(function (data) {
      var country = data && data.detected_values && data.detected_values.country;
      if (!country || typeof country.handle !== 'string') return;
      writeStorage('sessionStorage', sessionKey, '1');
      var language = countryLanguages[country.handle.toUpperCase()];
      if (!language || languages.indexOf(language) === -1 || manualChoice) return;
      if (languages.indexOf(readStorage('localStorage', preferenceKey)) !== -1) return;
      if (window.location.href !== url.href) return;

      url.pathname = '/' + language + (url.pathname === '/' ? '' : url.pathname);
      window.location.replace(url.href);
    })
    .catch(function () {
      // Keep the storefront usable when detection fails or times out.
    })
    .finally(function () { window.clearTimeout(timeout); });
})();
